import styled from 'styled-components';
import Colors from '../../../config/Colors';

export const ConfiguracaoHorarioContainer = styled.div`
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const Tab = styled.button.attrs({
    type: 'button'
})`
    border: none;
    background-color: ${Colors.white};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    min-width: 140px;

    border-bottom: ${({ isSelected }) =>
        isSelected && `2px solid ${Colors.blue_button}`};
`;

export const TabText = styled.span`
    color: ${Colors.regular};
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
    margin-bottom: 3px;
    margin-left: 0;

    ${({ isSelected }) =>
        isSelected ? `color: ${Colors.blue_button}; font-weight: bold;` : null}
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
`;

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid ${Colors.border};
    background-color: ${Colors.white};
    padding: 0 25px 0 25px;
    min-height: 65px;
    position: sticky;
    top: 0;
    z-index: 100;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const Text = styled.span`
    color: ${Colors.black};
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
    opacity: 0.8;
`;

export const TextClickable = styled.a`
    color: ${Colors.primary};
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
    opacity: 0.8;

    ${({ blue }) => blue && `color: ${Colors.primary}`};

    &:hover {
        cursor: pointer;
    }
`;

export const ScrollConfig = styled.div`
    padding: 25px 25px 50px 25px;
    flex-direction: column;
    display: flex;
    width: 100%;
`;

export const WarningDisabled = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 900px;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;

    background-color: ${Colors.grey_light};
`;

export const ConfigContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const ItemContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    flex-grow: 1;
    margin: 10px 0 10px 0;
    min-height: 40px;
`;

export const CheckBoxContainer = styled.div`
    min-width: 170px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const TimeCheckBoxButton = styled.button`
    background-color: ${Colors.white};
    cursor: pointer;
    border: none;

    padding-left: 0;
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;

    display: flex;
    flex-direction: row;
`;

export const DayCheckBox = styled.input.attrs({
    type: 'checkbox'
})`
    height: 1.5em;
    width: 1.5em;
    margin: 0 10px 0 0;
`;

export const TimeContainer = styled(ItemContainer)`
    flex-wrap: wrap;
`;

export const AddTimeButton = styled.button`
    max-width: 155px;
    height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.lightBlue};
    border: none;
    border-radius: 4px;

    &:hover {
        border: 1px solid ${Colors.secondary};
        cursor: pointer;
    }
`;

export const AddTimeText = styled.span`
    font-size: 1.2em;
    color: ${Colors.secondary};
    font-family: NunitoSans-Regular;
`;

export const Footer = styled.footer`
    border-top: 1px solid ${Colors.border};
    min-height: 50px;
    display: flex;
    width: 100%;
    position: sticky;
    background-color: ${Colors.white};
    bottom: 0;
    padding: 10px 0 10px 25px;
    z-index: 101;
`;

export const Button = styled.button`
    border: none;
    min-width: 180px;
    color: white;
    background-color: ${Colors.secondary};
    font-family: NunitoSans-Bold;
    font-weight: bold;
    border-radius: 4px;
`;
